import type { PropsWithChildren } from "react";

export const Previewer = ({ children }: PropsWithChildren<unknown>) => (
  <div className="bg-secondary flex size-full items-center justify-center">
    {children}
  </div>
);
